import { signal } from '@preact/signals-react';

export const AccountSubscriptionsDataIsDirty = signal(false);
export const AccountMessagesDataIsDirty = signal(true);
export const PublicProfileDataIsDirty = signal(true);
